import { graphql, useStaticQuery } from 'gatsby'
import '@src/data/prismic-fragments/capital'
import { Capital, capitalResolver } from '@src/utils/resolvers'

export default () => {
  const data = useStaticQuery(graphql`
    {
      allPrismicCapital(sort: { fields: data___title___text }) {
        nodes {
          ...prismicCapitalFragmentFull
        }
      }
    }
  `)

  const capitals: Capital[] = data.allPrismicCapital.nodes.map((node: any) =>
    capitalResolver(node)
  )
  return capitals
}
